import { Page } from 'components';
import { useContext } from 'react';
import {  Results } from './components';
import { ticketStatusesContext } from './TicketStatusesContext';


let TicketStatuses = () => {
    let { isLoading } = useContext(ticketStatusesContext);

    return (
        <Page
            isLoading={isLoading}
            useHeader={true}
            title="Ticket status"
            addNewUrl="/admin/ticketStatus/addnew"
        >
            <Results />
        </Page>
    )
}

export default TicketStatuses;